import { TypedUseSelectorHook, useSelector } from 'react-redux'
import type { AppRootState } from '../AppState/AppStore'

export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector
